export const SLICEMACHINE_CONFIG_FILENAME = "slicemachine.config.json";
